// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    height: 100%;
}

body,
html,
p,
ul,
ol,
li,
dl,
dd,
dt,
h1,
h2,
h3,
h4,
h5,
h6,
form,
fieldset,
input,
td,
th,
caption,
address,
textarea,
legend,
blockquote,
figure {
    margin: 0;
    padding: 0;
}

h1,
h2,
h3,
h4 {
    font-size: 100%;
    font-weight: normal;
}

img,
fieldset {
    border: 0;
}

ul,
ol {
    list-style-type: none;
}

table {
    border-collapse: collapse;
}

th,
td {
    vertical-align: top;
}

ins {
    text-decoration: none;
}

a:link, a:visited {
    outline: none;
    color: inherit;
    text-decoration: none;
}

* {
    outline-style: none;
    box-shadow: none;
    border-color: transparent;
}

#root, #popup {
    color-scheme: light dark;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    font-size: 17px;
    line-height: 24px;
}

@media screen and (min-width: 1920px) {
    #root, #popup {
        font-size: 20px;
        line-height: 32px;
    }
}

::selection {
    background: rgba(118, 51, 255, 0.16);
}

img,
svg {
    vertical-align: top;
}
`, "",{"version":3,"sources":["webpack://./src/main.css"],"names":[],"mappings":"AAAA;;IAEI,YAAY;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;IA0BI,SAAS;IACT,UAAU;AACd;;AAEA;;;;IAII,eAAe;IACf,mBAAmB;AACvB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,mBAAmB;AACvB","sourcesContent":["html,\nbody {\n    height: 100%;\n}\n\nbody,\nhtml,\np,\nul,\nol,\nli,\ndl,\ndd,\ndt,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nform,\nfieldset,\ninput,\ntd,\nth,\ncaption,\naddress,\ntextarea,\nlegend,\nblockquote,\nfigure {\n    margin: 0;\n    padding: 0;\n}\n\nh1,\nh2,\nh3,\nh4 {\n    font-size: 100%;\n    font-weight: normal;\n}\n\nimg,\nfieldset {\n    border: 0;\n}\n\nul,\nol {\n    list-style-type: none;\n}\n\ntable {\n    border-collapse: collapse;\n}\n\nth,\ntd {\n    vertical-align: top;\n}\n\nins {\n    text-decoration: none;\n}\n\na:link, a:visited {\n    outline: none;\n    color: inherit;\n    text-decoration: none;\n}\n\n* {\n    outline-style: none;\n    box-shadow: none;\n    border-color: transparent;\n}\n\n#root, #popup {\n    color-scheme: light dark;\n    min-height: 100%;\n    display: flex;\n    flex-direction: column;\n    font-size: 17px;\n    line-height: 24px;\n}\n\n@media screen and (min-width: 1920px) {\n    #root, #popup {\n        font-size: 20px;\n        line-height: 32px;\n    }\n}\n\n::selection {\n    background: rgba(118, 51, 255, 0.16);\n}\n\nimg,\nsvg {\n    vertical-align: top;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
